import styled from '@emotion/styled';
import { ExerciseUI } from '@seedlang/state';
import { isPresent } from '@seedlang/utils';
import Tags from 'components/worksheet/tags';
import { observer } from 'mobx-react';
import React from 'react';
import EpisodeCode from 'components/episode_code';

const SubtitleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
`;

const EpisodeCodeWrapper = styled.span`
  font-size: 14px;
  color: #636363;
  white-space: nowrap;
`;

const WorksheetSubtitleRow = observer(({episodeCode}) => {
  if (!ExerciseUI.worksheet) {
    return null;
  }

  const goBackToPosts = () => {
    const targetNamespace = ExerciseUI.worksheetNamespace === 'learn' ? 'videos' : ExerciseUI.worksheetNamespace;
    ExerciseUI.routeStore.routeToNamed(`${targetNamespace}.index`);
  };

  return (
    <SubtitleRow>
      {
        episodeCode && (
          <EpisodeCodeWrapper><EpisodeCode episodeCode={episodeCode} /></EpisodeCodeWrapper>
        )
      }
      {
        (isPresent(ExerciseUI.worksheet.worksheetTags) || isPresent(ExerciseUI.worksheet.episodeCode)) &&
          <Tags
            width={null}
            worksheet={ExerciseUI.worksheet}
            onUpdateFilter={goBackToPosts}
          />
      }
    </SubtitleRow>
  );
});

export default WorksheetSubtitleRow;